import AdminProjects from "./AdminProjects";

export default function AdminPacks() {
  return <AdminProjects libraryKey="sounds" />;
}
